module.exports = __webpack_public_path__ + "static/media/filter.8c103465.svg";